<template lang="pug">
  WtEntityTable.member-teams-table(
    title="My Team"
    has-large-title
    :data="memberTeams"
    default-sort-field="name"
    :enable-search="false"
    :search-fields="[]"
    empty-message="Your team will show here!"
  )
    BTableColumn(field="name" label="Team Name" sortable v-slot="column")
      .columns
        .column
          BTooltip(
            label="View this team"
            position="is-top"
            animated
          )
            WtRouterLink(
              to="Team"
              :params="{ teamId: column.row.teamNameURL }"
              :text="column.row.name"
              type="table"
            )
        .column.is-1(v-if="teamsMemberIsAdminLoaded && !!_.find(teamsMemberIsAdmin, {id: column.row.id})")
          WtRouterLink(
            to="MemberTeamEdit"
            :params="{ teamId: column.row.teamNameURL }"
            type="table"
          )
            BIcon(slot="icon" icon="settings" size="is-small")
    BTableColumn(field="numMembers" label="Member Size" centered v-slot="column")
      | {{ column.row.numMembers }} / {{ column.row.maxMembers }}
    BTableColumn(field="type" label="Type" centered v-slot="column")
      | {{ column.row.inviteOnly ? "Public/Invite Only" : "Public/Open" }}
</template>

<script>
import { mapGetters } from "vuex";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";

export default {
  name: "MemberTeamsTable",

  components: { WtEntityTable, WtRouterLink },

  computed: {
    ...mapGetters("members", [
      "memberTeams",
      "teamsMemberIsAdmin",
      "teamsMemberIsAdminLoaded"
    ])
  }
};
</script>

<style lang="sass" scoped></style>
